import AuthApi from "@/api/AuthApi";
import RouteEnum from "@/router/RouteEnum";
import router from '@/router/router'

class AuthService {
    login(user) {
        return AuthApi.login(user)
            .then(response => {
                if (response.data.token) {
                    localStorage.setItem('user', JSON.stringify(response.data));
                }
                return response.data;
            })
            .catch(function (error) {
                if (error.response.data && 401 === error.response.data.code) {
                    if (error.response.data) {
                        throw error.response.data.message
                    }
                } else {
                    alert("API Indisponible ");
                }

                throw error;
            });
    }

    getAuthToken() {
        let user = JSON.parse(localStorage.getItem('user'));

        if (user && user.token) {
            return user.token;
        }

        return null;
    }

    logout() {
        localStorage.removeItem('user');
        router.push({name: RouteEnum.LOGIN});
    }

    register(candidacy) {
        return AuthApi.register(candidacy)
    }
}

export default new AuthService();
